import { render, staticRenderFns } from "./welcome0.vue?vue&type=template&id=9c73dfb2&scoped=true"
import script from "./welcome0.vue?vue&type=script&lang=js"
export * from "./welcome0.vue?vue&type=script&lang=js"
import style0 from "./welcome0.vue?vue&type=style&index=0&id=9c73dfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c73dfb2",
  null
  
)

export default component.exports